/* Sticker motion engine: parallax + scroll-rotation for .sticker blocks.
   Each sticker drifts based on its own progress through the viewport, so
   motion is anchored to its home position and reverses with scroll. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let stickers = [];
  let observer = null;
  let screenHeight = window.innerHeight;
  let ticking = false;

  const collect = () => {
    if (observer) observer.disconnect();
    stickers = Array.from(document.querySelectorAll('[data-sticker]')).map((el) => ({
      el,
      mover: el.querySelector('[data-sticker-move]'),
      rotator: el.querySelector('[data-sticker-rotate]'),
      parallax: el.dataset.parallax === 'true',
      speed: parseFloat(el.dataset.parallaxSpeed || 3),
      baseRotate: parseFloat(el.dataset.baseRotate || 0),
      rotationMode: el.dataset.rotationMode,
      visible: true,
      height: el.offsetHeight || 100
    }));
    if (!stickers.length) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const s = stickers.find((s) => s.el === entry.target);
        if (s) s.visible = entry.isIntersecting;
      });
    }, { rootMargin: '25% 0px 25% 0px' });
    stickers.forEach((s) => observer.observe(s.el));
    animate();
  };

  const animate = () => {
    const scrollY = window.pageYOffset;
    stickers.forEach((s) => {
      if (!s.visible) return;
      if (s.parallax && s.mover) {
        const rect = s.el.getBoundingClientRect();
        const progress = (screenHeight - rect.top) / (screenHeight + s.height) - 0.5;
        const y = Math.round(s.speed * progress * 100 * 100) / 100;
        s.mover.style.transform = `translate(-50%, -50%) translateY(${y}px)`;
      }
      if (s.rotationMode === 'scroll' && s.rotator) {
        s.rotator.style.transform = `rotate(${s.baseRotate + scrollY / 3}deg)`;
      }
    });
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(animate);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', () => {
    screenHeight = window.innerHeight;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }

  /* keep the theme editor preview live as sections reload */
  document.addEventListener('shopify:section:load', collect);
})();
